export default __webpack_public_path__ + "static/cyclistic-a6afc152062b3128d3e9010fc0d5b283.png";